import type { CatalogItem } from '~/models/common'

export const gameLookingFor: CatalogItem[] = [
  {
    label: 'Feedback',
    value: 1,
  },
  {
    label: 'Investor',
    value: 2,
  },
  {
    label: 'Marketing',
    value: 3,
  },
  {
    label: 'Press',
    value: 7,
  },
  {
    label: 'Publisher',
    value: 4,
  },
]
